import { FC } from "react";
import { Modal } from "react-bootstrap";
import { BvIcon } from "bevi-icon";
import { ArticleBulkReplaceFileResult } from "../../../providers/Articles/ArticlesProvider";
import "./ModalArticlesReplaceFileBulkResult.scss";

interface ModalArticlesReplaceFileBulkResultProps {
  show: boolean;
  result: ArticleBulkReplaceFileResult | null;
  onClose: () => void;
}

const ModalArticlesReplaceFileBulkResult: FC<ModalArticlesReplaceFileBulkResultProps> = ({
  show,
  result,
  onClose,
}) => {
  if (!result) return null;

  const { replaced_ids, skipped, not_found_ids } = result;
  const skippedItems = [
    ...skipped.map((s) => ({ id: s.id, reason: s.reason })),
    ...not_found_ids.map((id) => ({ id, reason: "Artigo não encontrado" })),
  ];

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      dialogClassName="ModalArticlesReplaceFileBulkResult"
    >
      <Modal.Body>
        <BvIcon name="checkCircle" variant="solid" width={96} height={96} className="result-icon" />
        <h2 className="result-title">Concluído</h2>
        <p className="result-summary">
          <b>{replaced_ids.length} artigo(s)</b> tiveram o anexo atualizado.
        </p>

        {skippedItems.length > 0 && (
          <div className="result-skipped">
            <p className="result-skipped-title">
              <BvIcon name="error" variant="solid" width={20} height={20} />
              {skippedItems.length} artigo(s) foram pulados :
            </p>
            <ul>
              {skippedItems.map((item) => (
                <li key={item.id}>
                  <b>#{item.id}</b> - {item.reason}
                </li>
              ))}
            </ul>
          </div>
        )}

        <button type="button" className="btn btn-primary result-ok" onClick={onClose}>
          Ok
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default ModalArticlesReplaceFileBulkResult;
